import React from 'react';

const TabsSystem = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                group inline-flex items-center py-2 px-1 border-b-2 font-medium text-sm transition-all duration-200
                ${isActive
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon 
                className={`
                  mr-2 h-5 w-5 transition-colors duration-200
                  ${isActive 
                    ? 'text-primary-500' 
                    : 'text-gray-400 group-hover:text-gray-500'
                  }
                `} 
              />
              
              <span>{tab.label}</span>
              
              {/* Count Badge */}
              {tab.count !== undefined && (
                <span 
                  className={`
                    ml-2 py-0.5 px-2 rounded-full text-xs font-medium transition-colors duration-200
                    ${isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-gray-100 text-gray-600 group-hover:bg-gray-200'
                    }
                  `}
                >
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default TabsSystem;